import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=0eb03a7b"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"
import style0 from "./BetaBadge.vue?vue&type=style&index=0&id=0eb03a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports